/**
 * 프로토타입에서 아직 공개하지 않을 페이지 경로 목록
 * 여기에 포함된 경로 클릭 시 "화면 준비중입니다" alert 표시
 *
 * 공개하려면 해당 경로를 배열에서 제거하면 됩니다.
 */
export const blockedPaths = [
  // '/tour',        // 프라이빗 투어
  // '/shopping',    // 프라이빗 쇼핑
  // '/faq',         // 고객센터
  // '/partnership', // 제휴안내
  // '/about',       // 회사 소개
];

/**
 * 주어진 경로가 블로킹 대상인지 확인
 * @param {string} path - 확인할 경로
 * @returns {boolean}
 */
export function isBlockedPath(path) {
  return blockedPaths.some((bp) => path === bp || path.startsWith(bp + '/'));
}

/**
 * 블로킹된 링크 클릭 핸들러
 * @param {Event} e - 클릭 이벤트
 * @param {string} path - 대상 경로
 * @returns {boolean} true면 블로킹됨 (navigation 중단)
 */
export function handleBlockedClick(e, path) {
  if (isBlockedPath(path)) {
    e.preventDefault();
    alert('화면 준비중입니다.');
    return true;
  }
  return false;
}
